import { Component, OnInit, ViewChild } from '@angular/core';
import { jqxGridComponent } from 'jqwidgets-ng/jqxgrid';
import { jqxLoaderComponent } from 'jqwidgets-ng/jqxloader';
import { jqxWindowComponent } from 'jqwidgets-ng/jqxwindow';
import { NzModalService } from 'ng-zorro-antd/modal';
import { CrudService } from 'src/app/services/crud/crud.service';
import { MenuService } from 'src/app/services/menu/menu.service';
import { AplicacionModel } from 'src/app/services/sso/models/aplicacion.model';
import { EmpresaModel } from 'src/app/services/sso/models/empresa.model';
import { MenuAppEmpModel, MenuAppModel, MenuModel } from 'src/app/services/sso/models/menu.model';
import { JqWidgets } from 'src/app/utils/jqWidgets';
import { environment } from 'src/environments/environment';
import { MainComponent } from '../main/main.component';

@Component({
  selector: 'app-app-menu-emp',
  templateUrl: './app-menu-emp.component.html',
  styleUrls: ['./app-menu-emp.component.css']
})
export class AppMenuEmpComponent implements OnInit {
  @ViewChild('loader') loader: jqxLoaderComponent;
  @ViewChild('grid') grid: jqxGridComponent;
  @ViewChild('gridApp') gridApp: jqxGridComponent;
  @ViewChild('gridEmp') gridEmp: jqxGridComponent;
  @ViewChild('gridMenu') gridMenu: jqxGridComponent;
  @ViewChild('formAdd') formAdd: jqxWindowComponent;

  private componentRef = null;
  public environment = environment;

  // Variables para grid y dropdownlist
  public dataSource;
  public dataAdapter;
  public menusAdapter;
  public menusArray: MenuModel[] = [];
  public menus = new Map<number, MenuModel>();
  public apps = new Map<number, AplicacionModel>();
  public empresas = new Map<number, EmpresaModel>();
  public menuAppEmpSelec: MenuAppEmpModel;
  public appSelec: AplicacionModel;
  public empSelec: EmpresaModel;
  public menuSelec: MenuModel;
  public appsArray: AplicacionModel[] = [];
  public empArray: EmpresaModel[] = [];
  public rows: any[] = [];
  public mostrarEdit = false;
  public dataSourceApp;
  public dataAdapterApp;
  public dataSourceEmp;
  public dataAdapterEmp;
  public dataSourceMenu;
  public dataAdapterMenu;

  // Preparo las columnas del grid
  public columns = [
    {
      text: 'Id', columntype: 'textbox', datafield: 'id', width: 10, hidden: true
    },
    {
      text: 'AppId', columntype: 'textbox', datafield: 'appId', width: 10, hidden: true
    },
    {
      text: ' Aplicación', columntype: 'textbox', filtertype: 'textbox', datafield: 'appNombre', width: 320,
      editable: false,
      aggregates: [{
        'Total': function (aggregatedValue, currentValue: number) {
          return aggregatedValue + 1;
        }
      }],
      aggregatesrenderer: function (aggregates) {
        let renderstring = '';
        if (aggregates["Total"] !== undefined) {
          renderstring = '<div style="margin-left: 4px;">Total: ' +
            aggregates["Total"] + '</div>';
        }
        return renderstring;
      }
    },
    {
      text: 'EmpresaId', columntype: 'textbox', datafield: 'empId', width: 10, hidden: true
    },
    {
      text: 'Empresa', columntype: 'textbox', filtertype: 'textbox', datafield: 'empNombre', width: '320', editable: false
    },
    {
      text: 'MenuId', columntype: 'textbox', datafield: 'menuId', width: 10, hidden: true
    },
    {
      text: 'Menú', datafield: 'menuNombre', displayfield: 'MenuNombre', columntype: 'dropdownlist', width: 'auto',
      createeditor: (row: number, value: any, editor: any): void => {
        editor.jqxDropDownList({
          width: '250px', height: 32, source: this.menusAdapter,
          displayMember: 'label', valueMember: 'value'
        });
      }
    }
  ];

  // Preparo las columnas del grid de aplicaciones
  public columnsApp = [
    {
      text: 'Id', columntype: 'textbox', datafield: 'id', width: 10, hidden: true
    },
    {
      text: 'Aplicación', columntype: 'textbox', filtertype: 'textbox', datafield: 'nombre', width: 320,
      aggregates: [{
        'Total': function (aggregatedValue, currentValue: number) {
          return aggregatedValue + 1;
        }
      }],
      aggregatesrenderer: function (aggregates) {
        let renderstring = '';
        if (aggregates["Total"] !== undefined) {
          renderstring = '<div style="margin-left: 4px;">Total: ' +
            aggregates["Total"] + '</div>';
        }
        return renderstring;
      }
    }
  ];

  // Preparo las columnas del grid de empresas
  public columnsEmp = [
    {
      text: 'Id', columntype: 'textbox', datafield: 'id', width: 10, hidden: true
    },
    {
      text: 'Empresa', columntype: 'textbox', filtertype: 'textbox', datafield: 'nombre', width: 320,
      aggregates: [{
        'Total': function (aggregatedValue, currentValue: number) {
          return aggregatedValue + 1;
        }
      }],
      aggregatesrenderer: function (aggregates) {
        let renderstring = '';
        if (aggregates["Total"] !== undefined) {
          renderstring = '<div style="margin-left: 4px;">Total: ' +
            aggregates["Total"] + '</div>';
        }
        return renderstring;
      }
    }
  ];

  // Preparo las columnas del grid de menús
  public columnsMenu = [
    {
      text: 'Id', columntype: 'textbox', datafield: 'id', width: 10, hidden: true
    },
    {
      text: 'Menú', columntype: 'textbox', filtertype: 'textbox', datafield: 'nombre', width: 250,
      aggregates: [{
        'Total': function (aggregatedValue, currentValue: number) {
          return aggregatedValue + 1;
        }
      }],
      aggregatesrenderer: function (aggregates) {
        let renderstring = '';
        if (aggregates["Total"] !== undefined) {
          renderstring = '<div style="margin-left: 4px;">Total: ' +
            aggregates["Total"] + '</div>';
        }
        return renderstring;
      }
    }
  ];

  //  Esto es para que los textos en los controles del grid salgan en español
  public langGrid = JqWidgets.getLocalization('es');

  constructor(
    private menuService: MenuService,
    private crudService: CrudService,
    private modal: NzModalService) {
  }

  ngOnInit(): void {
  }

  // Este método es llamado por el creador del componente
  public init(componentRef: any) {
    this.componentRef = componentRef;
  }

  async ngAfterViewInit() {
    this.loader.open();
    this.appsArray = await this.crudService.getApps();
    this.empArray = await this.crudService.getEmpresas();
    this.menusArray = await this.menuService.getMenus();
    if (this.appsArray) {
      this.appsArray.forEach(app => {
        this.apps.set(app.Id, app);
      });
    }
    if (this.empArray) {
      this.empArray.forEach(emp => {
        this.empresas.set(emp.Id, emp);
      });
    }
    if (this.menusArray) {
      this.menusArray.forEach(menu => {
        this.menus.set(menu.Id, menu);
      });
    }
    this.fillGrid();
    this.loader.close();
  }

  // Rellena el grid
  async fillGrid() {
    this.loader.open();
    const menusApp = await this.menuService.getMenusAppEmp();
    if (menusApp) {
      this.rows = [];
      menusApp.forEach(appEmp => {
        let id, menuId, appId, menuNombre, appNombre, empId, empNombre;
        id = appEmp.Id;
        menuId = appEmp.MenuId;
        menuNombre = this.menus.get(menuId).Nombre;
        appId = appEmp.AplicacionId;
        appNombre = this.apps.get(appId).Nombre;
        empId = appEmp.EmpresaId;
        empNombre = this.empresas.get(empId).Nombre;
        this.rows.push({
          Id: id,
          AppId: appId,
          AppNombre: appNombre,
          MenuId: menuId,
          MenuNombre: menuNombre,
          EmpresaId: empId,
          EmpNombre: empNombre,
        });
      });
      // Creo un adaptador con los datos de todos los menús para poner en el combo
      const menusSource =
      {
        datatype: 'array',
        datafields: [
          { name: 'label', type: 'string', map: 'Nombre' },
          { name: 'value', type: 'number', map: 'Id' }
        ],
        localdata: this.menusArray
      };
      this.menusAdapter = new jqx.dataAdapter(menusSource, { autoBind: true });
      if (this.rows) {
        this.dataSource = {
          datatype: 'json',
          datafields: [
            { name: 'id', type: 'number', map: 'Id' },
            { name: 'appId', type: 'number', map: 'AppId' },
            { name: 'appNombre', type: 'string', map: 'AppNombre' },
            { name: 'empId', type: 'number', map: 'EmpresaId' },
            { name: 'empNombre', type: 'string', map: 'EmpNombre' },
            { name: 'menuId', type: 'number', map: 'MenuId' },
            {
              name: 'MenuNombre', value: 'MenuNombre',
              values: {
                source: this.menusAdapter.records, value: 'value', name: 'label'
              }
            },
            { name: 'menuNombre', type: 'string' },
          ],
          localdata: this.rows,
          sortcolumn: 'appNombre',
          sortdirection: 'asc'
        }
        this.dataAdapter = new jqx.dataAdapter(this.dataSource);
      }
    }
    this.loader.close();
  }

  onCellEndEdit(event: any) {
    const id = event.args.row.id;
    const appId = event.args.row.appId;
    const menuId = event.args.value.value;
    const empId = event.args.row.empId;
    const menu = {
      Id: id,
      MenuId: menuId,
      AplicacionId: appId,
      EmpresaId: empId
    }
    this.menuService.saveMenuAplicacionEmpresa(menu);
    MainComponent.showSuccess('ATENCIÓN', 'Registro almacenado', 2000);
    event.args.row.observ = this.menus.get(menuId).Observaciones;
  }

  onRowSelect(event: any) {
    this.menuAppEmpSelec = this.rows[event.args.rowindex];
  }

  onCrear() {
    this.mostrarEdit = true;
    this.appSelec = null;
    this.empSelec = null;
    this.menuSelec = null;
    const t = setTimeout(() => {
      clearTimeout(t);
      // Relleno el grid de aplicaciones
      this.dataSourceApp = {
        datatype: 'json',
        datafields: [
          { name: 'id', type: 'number', map: 'Id' },
          { name: 'nombre', type: 'string', map: 'Nombre' }
        ],
        localdata: this.appsArray,
        sortcolumn: 'nombre',
        sortdirection: 'asc'
      }
      this.dataAdapterApp = new jqx.dataAdapter(this.dataSourceApp);
      // Relleno el grid de empresas
      this.dataSourceEmp = {
        datatype: 'json',
        datafields: [
          { name: 'id', type: 'number', map: 'Id' },
          { name: 'nombre', type: 'string', map: 'Nombre' }
        ],
        localdata: this.empArray,
        sortcolumn: 'nombre',
        sortdirection: 'asc'
      }
      this.dataAdapterEmp = new jqx.dataAdapter(this.dataSourceEmp);
      // Relleno el grid de menús
      this.dataSourceMenu = {
        datatype: 'json',
        datafields: [
          { name: 'id', type: 'number', map: 'Id' },
          { name: 'nombre', type: 'string', map: 'Nombre' }
        ],
        localdata: this.menusArray,
        sortcolumn: 'nombre',
        sortdirection: 'asc'
      }
      this.dataAdapterMenu = new jqx.dataAdapter(this.dataSourceMenu);
    }, 1000);
  }

  onBorrar() {
    if (!this.menuAppEmpSelec) {
      MainComponent.showError('ATENCIÓN', 'Seleccione un registro de la lista', 2000);
      return;
    }
    this.modal.confirm({
      nzTitle: '<i>ATENCION</i>',
      nzContent: 'Quiere quitar el menú: ' + this.menus.get(this.menuAppEmpSelec.MenuId).Nombre + ' de la empresa:' +
        this.empresas.get(this.menuAppEmpSelec.EmpresaId).Nombre + ' ?',
      nzCentered: true,
      nzCancelText: 'CANCELAR',
      nzOkText: 'SI',
      nzOnOk: async () => {
        MainComponent.getInstance().showSuccess('ATENCION', 'Registro borrado', 2000);
        await this.menuService.deleteMenuAppEmpresa(this.menuAppEmpSelec.Id);
        for (let i = 0; i < this.rows.length; i++) {
          if (this.menuAppEmpSelec.Id === this.rows[i].Id) {
            this.rows.splice(i, 1);
            break;
          }
        }
        this.menuAppEmpSelec = null;
        this.grid.updatebounddata('cells');
      }
    });
  }

  onCloseAdd() {
    this.mostrarEdit = false;
  }

  onRowSelectApp(event: any) {
    this.appSelec = this.appsArray[event.args.rowindex];
  }

  onRowSelectEmp(event: any) {
    this.empSelec = this.empArray[event.args.rowindex];
  }

  onRowSelectMenu(event: any) {
    this.menuSelec = this.menusArray[event.args.rowindex];
  }

  onGuardar() {
    if (!this.appSelec) {
      MainComponent.showError('ATENCIÓN', 'Seleccione la aplicación', 2000);
      return;
    }
    if (!this.empSelec) {
      MainComponent.showError('ATENCIÓN', 'Seleccione la empresa', 2000);
      return;
    }
    if (!this.menuSelec) {
      MainComponent.showError('ATENCIÓN', 'Seleccione el menú', 2000);
      return;
    }
    this.modal.confirm({
      nzTitle: '<i>ATENCION</i>',
      nzContent: 'Quiere guardar la información ?',
      nzCentered: true,
      nzCancelText: 'CANCELAR',
      nzOkText: 'SI',
      nzOnOk: async () => {
        MainComponent.getInstance().showSuccess('ATENCION', 'Registro almacenado', 2000);
        const reg: MenuAppEmpModel = new MenuAppEmpModel();
        reg.Id = 0;
        reg.AplicacionId = this.appSelec.Id;
        reg.EmpresaId = this.empSelec.Id;
        reg.MenuId = this.menuSelec.Id;
        await this.menuService.saveMenuAplicacionEmpresa(reg);
        this.fillGrid();
        this.formAdd.close();
      }
    });
  }

}